"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareEmbedVideoCards = exports.prepareVideoCards = exports.isVideoCard = exports.isChannelCard = void 0;
var tslib_1 = require("tslib");
var types_1 = require("@wix/wix-vod-constants/dist/video-cards/types");
var get_resized_image_url_1 = require("../../common/utils/get-resized-image-url");
var isChannelCard = function (card) {
    return card.type === types_1.VIDEO_CARD_TYPES.CHANNEL;
};
exports.isChannelCard = isChannelCard;
var isVideoCard = function (card) {
    return card.type === types_1.VIDEO_CARD_TYPES.VIDEO ||
        card.type === types_1.VIDEO_CARD_TYPES.RECENT_VIDEO;
};
exports.isVideoCard = isVideoCard;
var shouldPlayInWidget = function (videoCard, channelId) {
    return (0, exports.isVideoCard)(videoCard) && channelId === videoCard.actionListId;
};
var prepareCard = function (_a) {
    var videoCard = _a.videoCard, thumbnailSize = _a.thumbnailSize, imageHost = _a.imageHost;
    return tslib_1.__assign(tslib_1.__assign({}, videoCard), { thumbnailUrl: (0, get_resized_image_url_1.getResizedImageUrl)({
            url: videoCard.thumbnailUrl,
            width: thumbnailSize,
            height: thumbnailSize,
            params: { lg: 1 },
            imageHost: imageHost,
        }) });
};
var prepareVideoCards = function (_a) {
    var videoCards = _a.videoCards, channelId = _a.channelId, thumbnailSize = _a.thumbnailSize, imageHost = _a.imageHost;
    return videoCards.map(function (videoCard) {
        var cardWithUrl = tslib_1.__assign(tslib_1.__assign({}, videoCard), { url: shouldPlayInWidget(videoCard, channelId) ? null : videoCard.url });
        return prepareCard({ videoCard: cardWithUrl, thumbnailSize: thumbnailSize, imageHost: imageHost });
    });
};
exports.prepareVideoCards = prepareVideoCards;
// NOTE: when video card opened in embed it always leads to user's website
var prepareEmbedVideoCards = function (_a) {
    var videoCards = _a.videoCards, thumbnailSize = _a.thumbnailSize, imageHost = _a.imageHost;
    return videoCards.map(function (videoCard) {
        return prepareCard({ videoCard: videoCard, thumbnailSize: thumbnailSize, imageHost: imageHost });
    });
};
exports.prepareEmbedVideoCards = prepareEmbedVideoCards;
//# sourceMappingURL=video-cards.js.map